import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";

export interface ImagePickerErrorMessages {
  tooMany: string;
  tooLarge: string;
  invalid: string;
}

export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const ACCEPTED_IMAGE_TYPES_ATTR = ACCEPTED_IMAGE_TYPES.join(",");
export const ACCEPTED_IMAGE_FILE_TYPES = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
};
export const MAX_IMAGES = 3;
export const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;

export const addImageFiles = (
  incoming: File[],
  images: File[],
  onAdd: (files: File[]) => void,
  errorMessages: ImagePickerErrorMessages,
) => {
  const accepted: File[] = [];
  for (const file of incoming) {
    if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
      errorSnackbar(errorMessages.invalid);
      continue;
    }
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      errorSnackbar(errorMessages.tooLarge);
      continue;
    }
    accepted.push(file);
  }
  if (accepted.length === 0) {
    return;
  }
  if (images.length + accepted.length > MAX_IMAGES) {
    errorSnackbar(errorMessages.tooMany);
    return;
  }
  onAdd([...images, ...accepted]);
};
